module.exports = __webpack_public_path__ + "img/arrow_forward.ca64d83c.svg";